/* src/app/dynamic-forms/form-view/form-view-date/form-view-date.component.css */
.mat-mdc-form-field {
  display: inline;
}
/*# sourceMappingURL=form-view-date.component.css.map */
